'use client';

import type { MediaPlayerInstance } from '@vidstack/react';

import {
  createContext,
  type ReactNode,
  RefObject,
  useContext,
  useState,
} from 'react';

interface PlayerContextValue {
  player: null | RefObject<MediaPlayerInstance | null>;
  setPlayer: (player: null | RefObject<MediaPlayerInstance | null>) => void;
}

const PlayerContext = createContext<PlayerContextValue | undefined>(undefined);

export function PlayerProvider({ children }: { children: ReactNode }) {
  const [player, setPlayer] =
    useState<null | RefObject<MediaPlayerInstance | null>>(null);
  return (
    <PlayerContext.Provider value={{ player, setPlayer }}>
      {children}
    </PlayerContext.Provider>
  );
}

export function usePlayer() {
  const context = useContext(PlayerContext);
  if (context === undefined) {
    throw new Error('usePlayer must be used within a PlayerProvider');
  }
  return context;
}
